import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannerNotificationService {
  private bannerSubject = new BehaviorSubject<app.models.BannerNotificationModel>({
    icon: '',
    translationString: '',
    isVisible: false,
  });

  banner$ = this.bannerSubject.asObservable();

  showBannerNotification(data: app.models.BannerNotificationModel) {
    this.bannerSubject.next({ ...data, isVisible: true });
  }

  hideBannerNotification() {
    this.bannerSubject.next({ ...this.bannerSubject.value, isVisible: false });
  }
}
